import { render, staticRenderFns } from "./Components.vue?vue&type=template&id=63f4cde5&scoped=true&"
import script from "./Components.vue?vue&type=script&lang=js&"
export * from "./Components.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f4cde5",
  null
  
)

export default component.exports